import { Router } from 'pjax';
import index from './index';
import manageEntryView from './manage-entry-view.js';
import feedback from './feedback.js';
import manageEntries from './manage-entries.js';
import manageDuplicates from './manage-duplicates.js';
import reviewEntries from './review-entries.js';
import preview from './preview.js';
import contract from './contract.js';

Router.get('entry/manager/([a-zA-Z]+)', manageEntryView);
Router.get('entry/manager/:any/preview', preview);
Router.get('entry/entrant', index);
Router.get('entry/entrant/:any/preview', preview);
Router.get('entry/manager', manageEntries);
Router.get('entry/feedback/:any', feedback);
Router.get('entry/review', reviewEntries);
Router.get('entry/duplicates/manage', manageDuplicates);
Router.get('entry/entrant/:any/contract/:any', contract);
